import {createFileRoute, redirect} from "@tanstack/react-router";
import {getAccessibleWorkspacesWithCaching} from "~/utilities/queries";

export const Route = createFileRoute(
    "/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/account-settings",
)({
    beforeLoad: async ({context}) => {
        const accessibleWorkspacesResult = await getAccessibleWorkspacesWithCaching({
            accessToken: context.authenticationStatus.accessToken,
            intellsysBaseUrl: context.intellsysBaseUrl,
            queryClient: context.queryClient,
        });

        if (accessibleWorkspacesResult.success !== true) {
            throw accessibleWorkspacesResult.error;
        }

        const firstWorkspace = accessibleWorkspacesResult.data[0];
        if (firstWorkspace === undefined) {
            throw redirect({
                to: "/u/select-workspace",
            });
        }

        throw redirect({
            to: "/w/$workspaceId/account-settings",
            params: {
                workspaceId: firstWorkspace.id,
            },
        });
    },
});
